import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl, getDecodedCookie } from '../../helpers/helperApp';

function ArticleTableEquiposl({ equipmentId, loading }) {

    const [ articleData, setArticleData ]   = useState([]);
    const [ loadingData, setLoadingData ]   = useState(false);
    const [ sortField, setSortField ]       = useState(null);
    const [ sortDir, setSortDir ]           = useState('asc');
    const [ search, setSearch ]             = useState('');

    useEffect(() => {
        if( equipmentId && equipmentId != 0 ){
            fetchArticleData();
        }
    }, [equipmentId]);

    const fetchArticleData = async () => {
        setLoadingData(true);
        try {
            const validacion = {
                id:     getDecodedCookie('id'),
                sesion: getDecodedCookie('sesion')
            };
            const data = new FormData();
            data.append("validacion", JSON.stringify(validacion));
            data.append("id", equipmentId);

            const url      = `${getApiUrl(window.location.origin)}/Equipos/getMaintenanceArticles`;
            const response = await axios.post(url, data);
            setArticleData(response.data || []);
        } catch (error) {
            console.error('Error fetching article data:', error);
            setArticleData([]);
        } finally {
            setLoadingData(false);
        }
    };

    const handleSort = (field) => {
        if( sortField === field ){
            setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDir('asc');
        }
    };

    const getSortIcon = (field) => {
        if( sortField !== field ) return <i className="fal fa-sort ml-1 text-muted" style={{fontSize:'0.7rem'}}></i>;
        return sortDir === 'asc'
            ? <i className="fal fa-sort-up ml-1" style={{fontSize:'0.7rem'}}></i>
            : <i className="fal fa-sort-down ml-1" style={{fontSize:'0.7rem'}}></i>;
    };

    const filteredData = articleData
        .filter(row =>
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(search.toLowerCase())
            )
        )
        .sort((a, b) => {
            if( !sortField ) return 0;
            const valA = String(a[sortField] || '').toLowerCase();
            const valB = String(b[sortField] || '').toLowerCase();
            return sortDir === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        });

    const styles = {
        wrapper: {
            background: '#f8f9fc',
            borderRadius: '10px',
            padding: '20px',
            marginTop: '16px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            flexWrap: 'wrap',
            gap: '10px'
        },
        title: {
            fontSize: '1rem',
            fontWeight: '600',
            color: '#2d3748',
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        },
        badge: {
            background: '#38a169',
            color: '#fff',
            borderRadius: '12px',
            padding: '2px 10px',
            fontSize: '0.75rem',
            fontWeight: '600'
        },
        searchInput: {
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            padding: '6px 12px',
            fontSize: '0.85rem',
            outline: 'none',
            width: '220px',
            background: '#fff'
        },
        table: {
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: 0,
            fontSize: '0.875rem'
        },
        th: {
            background: '#2d3748',
            color: '#e2e8f0',
            padding: '10px 14px',
            fontWeight: '600',
            fontSize: '0.78rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            borderBottom: '2px solid #4a5568'
        },
        thFirst: { borderTopLeftRadius: '8px' },
        thLast:  { borderTopRightRadius: '8px' },
        td: {
            padding: '10px 14px',
            borderBottom: '1px solid #edf2f7',
            color: '#4a5568',
            verticalAlign: 'middle'
        },
        trEven: { background: '#fff' },
        trOdd:  { background: '#f7fafc' },
        refBadge: {
            background: '#ebf4ff',
            color: '#3182ce',
            borderRadius: '4px',
            padding: '2px 8px',
            fontSize: '0.78rem',
            fontWeight: '600',
            fontFamily: 'monospace'
        },
        centroBadge: {
            background: '#faf5ff',
            color: '#805ad5',
            borderRadius: '4px',
            padding: '2px 8px',
            fontSize: '0.78rem',
            fontWeight: '500'
        },
        noData: {
            textAlign: 'center',
            padding: '40px',
            color: '#a0aec0',
            fontSize: '0.9rem'
        }
    };

    if( loading || loadingData ){
        return (
            <div style={{...styles.wrapper, textAlign:'center', padding:'40px'}}>
                <i className="fal fa-spinner fa-spin mr-2" style={{color:'#38a169', fontSize:'1.2rem'}}></i>
                <span style={{color:'#718096'}}>Cargando artículos...</span>
            </div>
        );
    }

    if( !equipmentId || equipmentId == 0 ){
        return (
            <div style={{...styles.wrapper, textAlign:'center', padding:'40px'}}>
                <i className="fal fa-box-open" style={{fontSize:'2rem', color:'#cbd5e0', display:'block', marginBottom:'10px'}}></i>
                <span style={{color:'#a0aec0'}}>Seleccione un equipo para ver sus artículos.</span>
            </div>
        );
    }

    return (
        <div style={styles.wrapper}>
            {/* Header */}
            <div style={styles.header}>
                <h6 style={styles.title}>
                    <i className="fal fa-box-open" style={{color:'#38a169'}}></i>
                    Artículos
                    <span style={styles.badge}>{ filteredData.length }</span>
                </h6>
                <input
                    type="text"
                    placeholder="🔍  Buscar..."
                    style={styles.searchInput}
                    value={search}
                    onChange={ e => setSearch(e.target.value) }
                />
            </div>

            {/* Table */}
            <div style={{overflowX:'auto', borderRadius:'8px', border:'1px solid #e2e8f0'}}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            {[
                                { label: 'Centro',             field: 'CENTRO' },
                                { label: 'Equipo',             field: 'EQUIPO' },
                                { label: 'Referencia Privada', field: 'REFERENCIA_PRIVADA' },
                                { label: 'Descripción',        field: 'DESCRIPCION' },
                                { label: 'Notas',              field: 'NOTAS' }
                            ].map((col, i, arr) => (
                                <th
                                    key={col.field}
                                    style={{
                                        ...styles.th,
                                        ...(i === 0 ? styles.thFirst : {}),
                                        ...(i === arr.length - 1 ? styles.thLast : {})
                                    }}
                                    onClick={ () => handleSort(col.field) }
                                >
                                    {col.label} {getSortIcon(col.field)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        { filteredData.length === 0
                            ? (
                                <tr>
                                    <td colSpan="5" style={styles.noData}>
                                        <i className="fal fa-inbox" style={{fontSize:'1.5rem', display:'block', marginBottom:'8px'}}></i>
                                        No hay artículos registrados para este equipo.
                                    </td>
                                </tr>
                            )
                            : filteredData.map((row, index) => (
                                <tr key={index} style={ index % 2 === 0 ? styles.trEven : styles.trOdd }>
                                    <td style={styles.td}>
                                        <span style={styles.centroBadge}>{ row.CENTRO }</span>
                                    </td>
                                    <td style={styles.td}>{ row.EQUIPO }</td>
                                    <td style={styles.td}>
                                        <span style={styles.refBadge}>{ row.REFERENCIA_PRIVADA }</span>
                                    </td>
                                    <td style={styles.td}>{ row.DESCRIPCION }</td>
                                    <td style={styles.td}>{ row.NOTAS }</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ArticleTableEquiposl;